module.exports = __webpack_public_path__ + "img/note.153fc760.svg";